export default __webpack_public_path__ + "e2fe92abe7b34b1937cb6ebb0a5fc996.svg";